import React, { useState, useEffect } from "react";
import * as yup from "yup";
import styles from "./member.module.css";
import { CountryCodes } from "utils/country_code";

import { Formik, Form, Field, ErrorMessage } from "formik";
import { Modal, Button, Row, Col } from "react-bootstrap";
import ApiActions from "api_actions";
import MyToast from "components/toast/toast";

import PolicyCheckbox from "components/payment_form/submit_booking_button/policy_checkbox/policy_checkbox";

export default function BecomeMember({ channelId, setMember }) {
  const [toast, setToast] = useState({ text: null, type: null });
  const [countryOptions, setCountryOptions] = useState([]);
  const [isPolicyAccepted, setIsPolicyAccepted] = useState(false);

  const [isToastShown, setIsToastShown] = useState(false);
  const getSchema = yup.object({
    full_name: yup
      .string()
      .required("Full name is required")
      .test(
        "is-valid-name",
        "Full name should contain both first and last names separated by a space",
        (value) => {
          if (!value) return false; // If value is empty, validation fails
          const names = value.trim().split(" ");
          return names.length === 2; // Check if there are exactly two names
        },
      ),
    phone: yup.number().typeError("Phone Number must be numeric").required(),
    country: yup.string().required(),
    email: yup
      .string()
      .required("Valid email is required.")
      .email("Please enter a valid email address."),
    zip: yup.string().required(),
  });

  useEffect(() => {
    const newCountryOptions = Object.keys(CountryCodes).map((countryName) => ({
      code: CountryCodes[countryName],
      name: countryName,
    }));
    setCountryOptions(newCountryOptions);
  }, []);

  useEffect(() => {
    if (toast.text && !isToastShown) {
      setIsToastShown(true);
    }
  }, [toast, isToastShown]);

  const handleSubmit = async (values, { setSubmitting }) => {
    await becomeMember(values);
    setSubmitting(false);
  };

  const becomeMember = async (values) => {
    const data = await ApiActions.becomeMember(values, channelId);

    if (data.status === 403) {
      setToast({ text: "Invalid Credentials!", type: "error" });
    } else if (data.status === 409) {
      setToast({ text: "Response Already submitted with this email", type: "error" });
    } else {
      setToast({ text: "member Added!", type: "success" });
    }
  };

  useEffect(() => {
    if (isToastShown) {
      setTimeout(() => {
        setMember(false);
      }, 3000);
    }
  }, [isToastShown, setMember]);

  return (
    <>
      <Modal
        show={!isToastShown}
        onHide={() => {
          setMember(false);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className={styles.title}>Become A member</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{
              email: "",
              full_name: "",
              phone: "",
              country: "",
              zip: "",
            }}
            validationSchema={getSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <Row>
                  <Col>
                    <label className={styles.label}>Full Name:</label>
                    <Field type="text" name="full_name" className={styles.input} />
                    <ErrorMessage name="full_name" component="div" className={styles.error} />
                  </Col>
                  <Col>
                    <label className={styles.label}>Email:</label>
                    <Field type="email" name="email" className={styles.input} />
                    <ErrorMessage name="email" component="div" className={styles.error} />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <label className={styles.label}>Phone Number:</label>
                    <Field type="tel" name="phone" className={styles.input} />
                    <ErrorMessage name="phone" component="div" className={styles.error} />
                  </Col>
                  <Col>
                    <label className={styles.label}>Country:</label>
                    <Field as="select" name="country" className={styles.input}>
                      <option value="">Select Country</option>
                      {countryOptions.map((country) => (
                        <option key={country.code} value={country.code}>
                          {country.name}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage name="country" component="div" className={styles.error} />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <label className={styles.label}>Zip:</label>
                    <Field type="text" name="zip" className={styles.input} />
                    <ErrorMessage name="zip" component="div" className={styles.error} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className={styles.btngroup}>
                      <PolicyCheckbox value={isPolicyAccepted} onChange={setIsPolicyAccepted} />
                      {/* <Field
                                                type="checkbox"
                                                name="checkbox"
                                                checked={isCheckboxChecked}
                                                onChange={(e) => setIsCheckboxChecked(e.target.checked)}
                                            />
                                            <span className={styles.checkboxLabel}> I agree to send the personal details</span> */}
                    </div>
                  </Col>
                </Row>

                <div className={styles.btngroup}>
                  <Button
                    type="submit"
                    disabled={isSubmitting || !isPolicyAccepted}
                    className={`${styles.submitbtn} ${
                      isSubmitting || !isPolicyAccepted ? styles.disabled : styles.enabled
                    }`}
                  >
                    Submit
                  </Button>

                  <Button
                    className={styles.cancelbtn}
                    onClick={() => {
                      setMember(false);
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
      {isToastShown && (
        <MyToast
          text={toast.text}
          type={toast.type}
          show={toast.text !== null}
          setShow={() => setToast({ text: null, type: null })}
        />
      )}
    </>
  );
}
